import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Loaders from "@/shared/components/loader";

function GoogleCallbackApp() {
  const location = useLocation();

  const getDataLogin = () => {
    window.location.href = `maxcoreapp://callbackGoogle?search=${location.search}`;
  };

  useEffect(() => {
    getDataLogin();
  }, []);

  return <Loaders />;
}

export default GoogleCallbackApp;
